import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-add-parking',
  templateUrl: './add-parking.component.html',
  styleUrls: ['./add-parking.component.css']
})
export class AddParkingComponent implements OnInit {

  @ViewChild('modalHide') modalHide;
  public addParkingForm:FormGroup;
  public parkingLocation = {};
  public selectedValueClose = false;
  public locationSuggestions = {};
  public fieldOptions=[{
    branch:[],
  }];
  public branchInformation=[];

  public locationObj = {};

  primaryMap: any;
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];
  markerId = 'parkingLocation';
  formSubmit:boolean=false;

  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,) { 
  }

  ngOnInit(): void {
    this.getBranchList();
    this.addParkingLoad();

    /* setTimeout(() => {
      this.loadMap();
      this.scrollToPageTop();
    }, 1000); */
  }
  /* API */
  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      console.log(res);
      if (res.status == 'success') {
        this.branchInformation = res.data;
        this.addBranchOptions();
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  addBranchOptions(){
    if(this.branchInformation && this.branchInformation.length>0){
      this.branchInformation.filter((e)=>{
        let option={name:e.branchName,value:e.branchID};
        this.fieldOptions[0].branch.push(option);
      });
    }
  }

  addParkingLoad(){
    this.addParkingForm = new FormGroup({
      title : new FormControl('', [Validators.required]),
      location : new FormControl('', [Validators.required]),
      branch : new FormControl('', [Validators.required]),
      isEnable : new FormControl('', [Validators.required]),
      radius : new FormControl('', [Validators.required]),
    });
  }

  getLocation(obj){
    console.log(obj);
    this.parkingLocation = {...obj};
  }

  /* checking error in fields*/
  public checkError = (controlName: string, errorName: string) => {
    return this.addParkingForm.controls[controlName].hasError(errorName);
  }

  /* Cancel Edit*/
  cancel(){
    this.router.navigate(['/organization/transport-manager/information/orgInfo/parking/view-parking']);
  }

  /* submit data*/
  onSubmit(){
    this.formSubmit = true;
    if (this.addParkingForm.valid){
      const obj = {
        orgID: this.storage.get('userInfo').orgID,
        ...this.addParkingForm.value
      };
      delete obj.location;
      obj.location={ ...this.parkingLocation };
  
      obj.isEnable=Number(obj.isEnable);
      console.log(obj);
      this.api.transportManagerParkingCreate(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/parking/view-parking'])
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
    }
}
